export default function OrientationsTimeline({ orientations, onOpenObs }: any) {
  if (!orientations || orientations.length === 0) {
    return (
      <div className="paper p-8 rounded-2xl">
        <div className="font-serif text-xl mb-2">Your restored orientations will appear here.</div>
        <div className="text-sm text-[#5c4633]">After you mark a moment and later close the loop with what feels steadier, what remains open, and any small shift in stance, those notes live in this timeline. This is the longitudinal record of your capacity to carry ambiguity.</div>
      </div>
    )
  }

  return (
    <div>
      <div className="font-serif text-2xl mb-1">My Orientations</div>
      <div className="text-sm text-[#5c4633] mb-6">The record of how you have metabolized what the work surfaces.</div>

      <div className="space-y-6">
        {orientations.map((o: any) => (
          <div key={o.id} className="restored rounded-2xl p-5">
            <div className="text-xs text-[#5c4633] mb-2">{new Date(o.restoration_at || o.created_at).toLocaleDateString()}</div>
            
            <div onClick={() => onOpenObs(o.id)} className="cursor-pointer font-serif text-[15px] leading-snug mb-4 hover:text-[#4a3f6b]">
              {o.description?.slice(0, 280)}{o.description?.length > 280 ? '…' : ''}
            </div>

            <div className="grid md:grid-cols-3 gap-4 text-sm">
              <div>
                <div className="text-xs text-[#4a3f6b] mb-1">Steadier</div>
                <div className="font-serif">{o.restoration_steadier || '—'}</div>
              </div>
              <div>
                <div className="text-xs text-[#4a3f6b] mb-1">Remains open</div>
                <div className="font-serif">{o.restoration_open || '—'}</div>
              </div>
              <div>
                <div className="text-xs text-[#4a3f6b] mb-1">Small shift</div>
                <div className="font-serif">{o.restoration_shift || '—'}</div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 text-[11px] text-[#5c4633]">These notes belong to you. Export them. Re-read them before difficult days. They are the real output of the commons.</div>
    </div>
  )
}
